import React from 'react';

import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';

import {DropdownMenu} from 'components/ui-kit/DropdownMenu';
import {ROUTE} from 'core/routes';

import {ControlsWrapper} from './styled';

export const Controls = () => {
    const {t} = useTranslation();
    const history = useHistory();
    return (
        <ControlsWrapper>
            <DropdownMenu label={t('pages.orders.create')}>
                <DropdownMenu.List>
                    <DropdownMenu.Item onSelect={() => history.push(ROUTE.ORDERS_CREATE_CUSTOMER)}>
                        {t('pages.orders.createConsumerCodes')}
                    </DropdownMenu.Item>
                    <DropdownMenu.Item onSelect={() => history.push(ROUTE.ORDERS_CREATE_TRANSPORT)}>
                        {t('pages.orders.createTransportCodes')}
                    </DropdownMenu.Item>
                    <DropdownMenu.Item onSelect={() => history.push(ROUTE.ORDERS_CREATE_CUSTOMS)}>
                        {t('pages.orders.createCustomsCodes')}
                    </DropdownMenu.Item>
                </DropdownMenu.List>
            </DropdownMenu>
        </ControlsWrapper>
    );
};
